"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SESSION_STORAGE_KEY = 'SESSION_STORAGE';
//# sourceMappingURL=index.js.map